import Joi from "joi";
import { TUserPendingFormValues } from "../components/FlightEnquiryForm/CreateNewAgent";

export const detailPendingUserSchema = Joi.object({
  // userType: Joi.string().required().label("User Type"),
  // email: Joi.string().label("Email").required(),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .optional()
    .allow(""),
  firstName: Joi.string().required().label("First Name"),
  lastName: Joi.string().optional().label("Last Name").allow(""),
  phoneCode: Joi.string().required().label("Phone Code"),
  phone: Joi.string().required().label("Phone"),
  companyName: Joi.string().optional().label("Company Name").allow(""),
  panNumber: Joi.string().label("PAN").allow(""),
  gst: Joi.string().allow("").label("GST"),
}).required();

export const validateUserDetailsSchema = (data: TUserPendingFormValues) => {
  let errors: any;
  let errorMessage: string | null = null;

  if (!data.phone) {
    errorMessage = "phone  number is required.";
  }
  if (!data.firstName) {
    errorMessage = "First Name is required.";
  }
  if (data.phone.length < 10 || data.phone.length > 10) {
    errorMessage = "Enter correct phone number";
  }

  return { errors, errorMessage };
};

/////////
